"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CheckboxSqliteHandler", {
    enumerable: true,
    get: function() {
        return CheckboxSqliteHandler;
    }
});
const _checkboxgeneralhandler = require("./checkbox.general.handler");
let CheckboxSqliteHandler = class CheckboxSqliteHandler extends _checkboxgeneralhandler.CheckboxGeneralHandler {
    async parseDbValue(params) {
        if (params.value === 1) {
            return {
                value: true
            };
        } else if (params.value === 0) {
            return {
                value: false
            };
        } else {
            return {
                value: params.value
            };
        }
    }
};
